import { Button, Intent, Popover, Tab, Tabs } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";

import styled, { css } from "styled-components";
import ApplyChanges from "./ApplyChanges";
import ConfigEditor from "./ConfigEditor";
import { default as EditorConfigForm, EditorConfig } from "./EditorConfigForm";
import LabelList from "./label/LabelList";
import PropertyEditor from "./properties/PropertyEditor";
import { Logo } from "./styled/fragments";
import SystemHealth from "./SystemHealth";
import SystemInfo from "./SystemInfo";
import SystemPanel from "./SystemPanel";
import MetricsPanel from "./MetricsPanel";
import ServicesPanel from "./ServicesPanel";

interface IGlobalSettingsPanelProps {
	config: EditorConfig;
	onChange: (config: EditorConfig) => void;
}

const AdminWrapper = styled.div`
	background: rgb(26, 41, 50); /*rgb(15, 37, 47);*/
	height: 100vh;
	display: grid;
	grid-template:
    ' top-left . ' auto
    ' main main ' 1fr
    / 1fr 5fr;
    color: rgb(167, 182, 194);
	
	.header {
		display: flex;
		justify-content: space-between;
		background: rgb(26, 30, 32);
		padding: 10px 15px 0px 15px;
		display: flex;
		align-items: center;
		z-index: 50;
		grid-area: top-left;
		border-right: 1px solid rgba(0,0,0,0.4);
		min-width: 200px;
	}

	html &, body & {}
	
	.bp3-tabs.bp3-vertical {
		grid-area: main;
		display: grid;
		grid-template: "side main" / 1fr 5fr;
	}
	
	.bp3-tabs.bp3-vertical > * {
		padding: 20px;
		grid-area: main;
		/*box-shadow: inset #0e0e0d -6px 0px 10px 4px;*/
	}
	
	.bp3-tabs .bp3-tab-panel {
		width: 100%;
		display: grid;
	}
	
	.bp3-tabs.bp3-vertical > .bp3-tab-list .bp3-tab {
		padding: 7px 20px;
		border-radius: 0;
		border-top: 1px solid rgba(0,0,0,0.4);
	}
	
	.bp3-tabs.bp3-vertical > .bp3-tab-list .bp3-tab:last-child {
		border-bottom: 1px solid rgba(0,0,0,0.4);
	}
	
	.bp3-tabs.bp3-vertical > .bp3-tab-list {
	    background: rgb(26, 30, 32);
		border-right: 1px solid rgba(0,0,0,0.4);
		padding: 20px 0;
		min-width: 200px;
		grid-area: side;
		box-shadow: none;
	}
	
	.bp3-tabs.bp3-vertical > .bp3-tab-list .bp3-tab-indicator-wrapper .bp3-tab-indicator {
		border-radius: 0;
	}
`;

export default class AdminPage extends React.Component<IGlobalSettingsPanelProps> {

	public render() {
		return this.renderTabs();
	}

	private renderTabs = () => {
		return (
			<AdminWrapper className="bp3-dark">
				<div className="header">
					<Popover content={<SystemInfo />} usePortal={false}>
						<Logo />
					</Popover>

					<div>
						<Popover content={<SystemHealth />} usePortal={false}>
							<Button icon={IconNames.PULSE} minimal={true} intent={Intent.NONE} />
						</Popover>
						<ApplyChanges />
					</div>
				</div>
				<Tabs id="site-settings" vertical={true} renderActiveTabPanelOnly={true} defaultSelectedTabId="properties">
					<Tab id="system" title="System" panel={<SystemPanel />}/>
					<Tab id="properties" title="Properties" panel={<PropertyEditor openTarget={PropertyEditor.TARGET_CHILD}/>}/>
					<Tab id="metrics" title="Metrics" panel={<MetricsPanel />}/>
					<Tab id="services" title="Services" panel={<ServicesPanel />}/>
					<Tab id="labels" title="Labels" panel={<LabelList useDialog={false}/>}/>
					<Tab id="json" title="Edit JSON" panel={<ConfigEditor/>}/>
					<Tab id="prefs" title="Editor Preferences" panel={<EditorConfigForm config={this.props.config} onChange={this.props.onChange}/>}/>
				</Tabs>
			</AdminWrapper>
		);
	}
}



// WEBPACK FOOTER //
// ./src/core/components/editor/AdminPage.tsx